import { InfoIcon } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "../ui/alert";

/**
 * Says which quantity the reader is looking at.
 *
 * The page carries two numbers that both look like money and are not the same
 * thing: what the work would have cost at provider list prices, and what the
 * CMMD subscription has actually consumed. Someone who reads the first as a
 * bill will think they are being overcharged by orders of magnitude. This
 * section states its own quantity and names the other; the CMMD plan card on
 * Connected subscriptions does the same in the opposite direction, so neither
 * can be mistaken for the one it is not.
 */
export function UsageEstimateNotice() {
  return (
    <Alert variant="info">
      <InfoIcon />
      <AlertTitle>Estimated value, not money spent</AlertTitle>
      <AlertDescription>
        <p>
          Every recorded turn, priced at each provider&rsquo;s published API rates. You are running
          on your own keys and subscriptions, so this is not what you were charged — it is what the
          same work would have cost had you paid per token.
        </p>
        <p>What your CMMD plan has left this period is under Connected subscriptions.</p>
      </AlertDescription>
    </Alert>
  );
}
